/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import React, { useState, useRef, useEffect } from 'react';
import GoogleAnalytics from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';

import Weeks from './components/weeks';
import Hours from './components/hours';
import Loading from './components/common/loader';

import {
  mapadoreIsRange,
  dayRange,
  googleAnalitycs_tecma,
  pixel_tecma,
  durationInMinutes,
  googleTagManagerId_project,
  googleTagManagerId_AbitareGlobal,
} from './config.json';
import {
  fetchAppointments,
  setAppointments,
  getLogin,
  getJwt,
} from './services/authService';
import Dialogue from './components/common/dialogue';
import Error from './components/common/error';
import getDateObject, {
  getAllDays,
  getPaginatedItems,
  getAllHours,
  getEvent,
  getHours,
  getMinutes,
} from './datefunctions';

// const savedResults = require('./result.json');

// initialiazes google anyalitics

const NewApp = () => {
  // gets all the days within the day range
  const allDays = getAllDays(dayRange);



  // const [AppointmentTypeValue, setAppointmentTypeValue] = useState('');

  // useEffect(() => {
  // setAppointmentTypeValue(localStorage.getItem('appointmentType', AppointmentTypeValue));
  // }, [AppointmentTypeValue]);


  GoogleAnalytics.initialize(
    [
      {
        trackingId: googleAnalitycs_tecma,
        gaOptions: { name: 'tecma' },
      },
    ],
    { debug: false, alwaysSendToDefaultTracker: false }
  );

  // Facebook Pixel Initialization
  ReactPixel.init(pixel_tecma);

  //Google tag-manager
  TagManager.initialize({
    gtmId: googleTagManagerId_AbitareGlobal,
  });
  TagManager.initialize({
    gtmId: googleTagManagerId_project,
  });

  // Number of days per page
  const numberOfDaysPerPage = 7;
  // days to be shown in each page
  const [days, setDays] = useState(
    getPaginatedItems(allDays, 1, numberOfDaysPerPage)
  );
  // selected day, initialy the first one of the active ones
  const [selectedDay, setSelectedDay] = useState(
    days.filter((itm) => itm.active === true)[0]
  );
  // current page in the pagination
  const [currentDayPage, setCurrentDayPage] = useState(1);
  // selected event / appointment
  const [selectedEvent, setSelectedEvent] = useState({
    hours: '00:00-00:00',
    eventId: null,
  });
  // array containing the available hours of appointments for each day
  let hours = [];

  // app status : error, success, confirmation
  const [status, setStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState({
    title: 'Riprova più tardi cliccando qui',
    subtitle1: '',
    subitle: '',
  });

  // handles selecting the week
  const handleWeekSelect = (page) => {
    // sets the selected event initialy
    setSelectedEvent({ eventId: null, hours: '00:00-00:00' });

    const daysInCurrentPage = getPaginatedItems(
      allDays,
      page,
      numberOfDaysPerPage
    );
    setDays(daysInCurrentPage);
    setCurrentDayPage(page);
    // get the first active item of the days list as the deafult selected day
    setSelectedDay(daysInCurrentPage.filter((itm) => itm.active === true)[0]);
  };

  const handleHoursSelect = (eventId, hours) => {
    setSelectedEvent({ eventId, hours });
  };

  const handleDaySelect = (day) => {
    setSelectedEvent({ eventId: null, hours: '00:00-00:00' });
    setSelectedDay(day.item);
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    // eslint-disable-next-line react/destructuring-assignment
    if (getJwt() && getLogin()) {
      const event = getEvent(
        dates,
        selectedEvent.eventId,
        selectedEvent.hours
      )[0];
      // setStatus(setAppointments(event))
      loading.current = true;
      setStatus('loading');
      setAppointments(event)
        .then((res) => {
          if (res.status === 'success') setStatus('success');
          else setStatus('error');
          if (res.data.errorCode === 'TIME_ALREADY_ALLOCATED') {
            setErrorMessage({
              subtitle1: 'Purtoppo sei arrivato tardi!',
              subtitle2:
                'Qualcun altro ha appena preso un appuntamento per questa fascia oraria.',
              title:
                'Per favore prova a cambiare orario o giorno cliccando qui',
            });
          }
        })
        .then(() => {
          loading.current = false;
        })
        .catch((err) => {
          setStatus(err);
        });
    } else {
      window.location.reload(false);
    }
  };

  const handleSubmitConfirm = () => {
    if (selectedEvent.eventId) setStatus('confirmation');
  };

  const handleCancelSubmit = () => {
    setStatus('');
  };

  // console.log("savedresutl", savedResults);

  const [apiData, setApiData] = useState(null);
  const loading = useRef(false);
  useEffect(() => {
    loading.current = true;
    fetchAppointments(selectedDay.timestamp)
      .then((res) => {
        // setApiData({data:{...savedResults, scheduledEvents: []}});
        setApiData(res);
      })
      .then(() => {
        loading.current = false;
      })
      .catch(() => {
        setStatus('error');
        setErrorMessage({
          title: 'Riprova più tardi cliccando qui',
          subtitle1: '',
          subitle2: '',
        });
      });

    return () => {};
  }, [selectedDay.timestamp]);
  let dates = null;

  if (apiData && getJwt()) {
    // TODO: if data is null shows an error page , remove the session data
    dates = apiData.data.results
      .filter((item) => item.is_range === mapadoreIsRange)
      .map((result) => ({
        appointment: {
          location: {
            target_address: result.target_address,
            latitude: result.latitude,
            longitude: result.longitude,
          },
          time: {
            startTime: getDateObject(result.start_time),
            finishTime: getDateObject(result.finish_time),
          },
          mapadore_event_id: result.mapadore_event_id,
          operator_id: result.operator_id,
          operator_name: result.operator_name,
          target_id: result.target_id,
        },
      }));
    // console.log(dates, dates );

    hours = dates.length
      ? getAllHours(
          dates,
          selectedDay.day,
          selectedDay.month,
          mapadoreIsRange,
          durationInMinutes
        )
      : [];
  }

  if (apiData && apiData.data.results.length === 0) hours = [];
  let scheduledEvent = null;
  if (apiData && apiData.data.scheduledEvents.length !== 0) {
    scheduledEvent = apiData.data.scheduledEvents[0];
  }

  // if (hours = null && loading.current) hours = [];
  const h =
    selectedEvent && selectedEvent.hours
      ? selectedEvent.hours.split('-')
      : ['00:00', '00:00'];
  const date = new Date(
    selectedDay.year,
    selectedDay.month - 1,
    selectedDay.day
  ).toLocaleDateString('it-IT', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  const selectedHoursText = `${date} dalle ${h[0]} alle ${h[1]}`;

  if (scheduledEvent) {
    const finishTime = new Date(scheduledEvent.finish_time);
    const startTime = new Date(scheduledEvent.start_time);
    if (finishTime.getTime() > new Date().getTime()) {
      const selectedHoursText = `${finishTime.toLocaleDateString('it-IT', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      })} dalle  ${getHours(startTime)}:${getMinutes(
        startTime
      )} alle ${getHours(finishTime)}:${getMinutes(finishTime)}`;
      return (
        <>
          <Dialogue
            title="Ha già fissato un appuntamento!"
            logoClass="success_logo"
            subtitle="il tuo appuntamento è previsto per il giorno:"
            data={selectedHoursText}
          />
          {/* <MapDialogue
            isMarkerShown
            lat={scheduledEvent.latitude}
            lng={scheduledEvent.longitude}
            googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<Loading type="Rings" />}
            containerElement={<div style={{ height: '400px' }} />}
            mapElement={<div style={{ height: '100%' }} />}
          /> */}
        </>
      );
    }
  }

  switch (status) {
    case 'success': {
      const page = `${
        window.location.pathname + window.location.search
      }thank-you/`;

      GoogleAnalytics.pageview(page, ['tecma']);
      ReactPixel.pageView(page);
      ReactPixel.fbq('track', 'PageView');
      ReactPixel.fbq('track', 'Lead');
      return (
        <Dialogue
          title="Grazie per aver fissato l’appuntamento.
           "
          logoClass="success_logo"
          subtitle="Riceverai un’email da parte del nostro venditore con le istruzioni per svolgere l’appuntamento."
          subtitle2="Il tuo appuntamento è previsto per il giorno:"
          data={selectedHoursText}
        />
      );
    }
    case 'confirmation':
      return (
        <Dialogue
          title="Conferma la tua prenotazione"
          logoClass="question_logo"
          subtitle = {
            `Confermi di voler fissare un appuntamento presso l'Info Point per:`
          }
          // subtitle = {
          //   `Confermi di voler fissare un appuntamento ${AppointmentTypeValue} per:`
          // }
          data={selectedHoursText}
          dialogueButtons={[
            {
              text: 'Sì',
              cssClass: 'button yes button-submit',
              handleClick: handleSubmit,
            },
            {
              text: 'No',
              cssClass: 'button no',
              handleClick: handleCancelSubmit,
            },
          ]}
        />
      );
    case 'error':
      return (
        <Error
          title="Abbiamo riscontrato un problema."
          logoClass="error_logo"
          subtitle={errorMessage.title}
          subtitle1={errorMessage.subtitle1}
          subtitle2={errorMessage.subtitle2}
          link="/"
        />
      );
    case 'loading':
      return (
        <Loading
          type="Rings"
          title="Attendi mentre confermiamo l'appuntamento richiesto"
        />
      );
    default:
      break;
  }
  return getLogin() ? (
    <>
      <h1 className="title">
        Seleziona il giorno e l&#x27;ora per il tuo appuntamento
      </h1>
      <Weeks
        loading={loading}
        days={days}
        nextPage={
          currentDayPage < Math.ceil(allDays.length / numberOfDaysPerPage)
            ? currentDayPage + 1
            : 0
        }
        prevPage={currentDayPage > 1 ? currentDayPage - 1 : 0}
        daySelect={handleDaySelect}
        handleWeekSelect={handleWeekSelect}
        selectedDay={selectedDay.day}
      />
      <p className="selectedday">
        {new Date(selectedDay.date).toLocaleString('it-IT', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </p>
      {!loading.current && hours && !hours.length ? (
        <>
          <p className="subtitle" />
          <div className="hours-choice_wrapper">
            <Loading type="Rings" />
          </div>
        </>
      ) : hours.length === 0 ? (
        <>
          <p className="subtitle" />
          <div className="hours-choice_wrapper">
            <div className="message">
              Non ci sono appuntamenti disponibili, ti preghiamo di selezionare
              un&apos;altra data
            </div>
          </div>
        </>
      ) : hours.length !== 0 ? (
        <Hours
          selectedDay={selectedDay}
          hoursSelect={handleHoursSelect}
          hours={hours}
          selectedEvent={selectedEvent}
          loading={loading}
        />
      ) : null}
      <div
        role="button"
        tabIndex="0"
        className="submit"
        onClick={handleSubmitConfirm}
        style={
          selectedEvent.eventId !== null
            ? { cursor: 'pointer', backgroundColor: '#e30613' }
            : { backgroundColor: ' #d1d1d1' }
        }
        onKeyPress={handleSubmitConfirm}
      >
        Conferma
      </div>
    </>
  ) : (
    <Error
      title="Abbiamo riscontrato un problema."
      logoClass="error_logo"
      subtitle="Fai clic qui per riprovare"
      subtitle1="La sua sessione è scaduta."
      link="/"
    />
  );
};

export default NewApp;
